import React from "react";
import CounterInput from "components/ui/CounterInput";
import RailcardSelector from "components/RailcardsSelector";
import Button from "components/ui/Button";
import "styles/components/passengers-form.scss";
import useLayout from "hooks/useLayout";

const PASSENGERS_MAX = 9;

const PassengersForm = ({
  adults,
  children,
  onAdultsChange,
  onChildrenChange,
  onHide,
  onRailcardsChange,
  passengers,
  railcards,
  disableRailcards,
}) => {
  const { isMobile } = useLayout();

  return (
    <div className="otrl-jp__passengers-form">
      <div className="otrl-jp__passengers-form__row">
        <div className="otrl-jp__passengers-form__row__group" id="otrl-jp__passengers-form-adults">
          <span className="otrl-jp__passengers-form__row__text">Adults</span>
          <span className="otrl-jp__passengers-form__row__subtext">16+ years</span>
        </div>
        <CounterInput
          className="otrl-jp__passengers-form__row__counter"
          initial={adults}
          onChange={onAdultsChange}
          max={PASSENGERS_MAX - children}
          label="Adults"
          ariaDescribedBy="otrl-jp__passengers-form-adults"
        />
      </div>
      <div className="otrl-jp__passengers-form__row">
        <div className="otrl-jp__passengers-form__row__group" id="otrl-jp__passengers-form-children">
          <span className="otrl-jp__passengers-form__row__text">Children</span>
          <span className="otrl-jp__passengers-form__row__subtext">5-15 years</span>
        </div>
        <CounterInput
          className="otrl-jp__passengers-form__row__counter"
          initial={children}
          onChange={onChildrenChange}
          max={PASSENGERS_MAX - adults}
          label="Children"
          ariaDescribedBy="otrl-jp__passengers-form-children"
        />
      </div>
      <div className="otrl-jp__passengers-form__row otrl-jp__passengers-form__row--no-border">
        <span className="otrl-jp__passengers-form__row__subtext">Children under 5 travel free</span>
      </div>
      {!disableRailcards &&
        <RailcardSelector
          passengers={passengers}
          railcards={railcards}
          onRailcardsChange={onRailcardsChange}
        />
      }
      {!isMobile &&
        <Button className="otrl-jp__passengers-form__button" text="Done" onClick={onHide} />
      }
    </div>
  );
};

export default PassengersForm;
